import { Injectable } from '@angular/core';
import { FormbirdInjectorService } from '../injector/formbird-injector.service';

@Injectable({
  providedIn: 'root'
})
export class SearchService {
  searchService: any;

  constructor(private formbirdInjectorService: FormbirdInjectorService) {
    this.searchService = formbirdInjectorService.get('SearchService');
  }

  /**
   * Do Elastic search on server side. If the browser is offline, do searching indexedDB.
   * @param options consists of text, filter query to search
   * @param searchContext an object consists of additional params
   * @returns Promise
   */
  search(options, searchContext?): Promise<any> {
    return this.searchService.search(options, searchContext);
  }
}
